var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 233,
    viewBox: "0 0 350 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.228 171.817C129.632 168.06 125.968 165.432 121.703 165.432C120.528 165.432 119.399 165.631 118.346 165.999C116.347 162.908 112.914 160.869 109.016 160.869C105.287 160.869 101.984 162.734 99.9547 165.601C99.1428 165.12 98.1998 164.845 97.1938 164.845C96.3133 164.845 95.4809 165.056 94.7426 165.431C92.7486 160.238 87.7975 156.562 82.0053 156.562C76.687 156.562 72.0777 159.661 69.8156 164.188C68.4783 163.547 66.9851 163.188 65.41 163.188C60.3385 163.188 56.1167 166.905 55.2112 171.817H131.228Z",
    fill: "#D0D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4167 172.711H310.917",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0833 172.711H42.5833",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.667 180.866H284.667",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.583 180.866H271.833",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3333 172.42L108.792 136.887L142.333 163.172",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.417 154.912L142.625 146.208L175 172.42",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.728 152.871L166.25 165.43L159.699 159.667L161.605 152.871C161.692 152.561 162.014 152.38 162.324 152.467C162.52 152.522 162.673 152.675 162.728 152.871Z",
    fill: "#D0D0D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7302 151.076L86.749 154.891L82.8333 157.703L84.6029 151.076C84.686 150.765 85.0056 150.581 85.3169 150.664C85.5187 150.717 85.6764 150.875 85.7302 151.076Z",
    fill: "#D0D0D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.495 136.278L258.86 165.106C259.039 165.724 258.682 166.37 258.064 166.549C257.958 166.579 257.849 166.595 257.739 166.595H241.011C240.367 166.595 239.844 166.073 239.844 165.43C239.844 165.32 239.86 165.211 239.89 165.106L248.254 136.278C248.434 135.66 249.081 135.304 249.7 135.483C250.084 135.595 250.384 135.895 250.495 136.278Z",
    fill: "#D0D0D0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.375 135.329L259.292 166.595H239.458L249.375 135.329Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.375 137.875C249.375 160.214 249.375 171.632 249.375 172.129C249.375 171.632 249.375 160.214 249.375 137.875Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.042 152.221C250.931 155.985 249.375 157.926 249.375 158.046C249.375 157.926 250.931 155.985 254.042 152.221Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.461 115.918L243.18 165.096C243.364 165.713 243.013 166.362 242.396 166.546C242.287 166.579 242.175 166.595 242.062 166.595H214.861C214.217 166.595 213.694 166.073 213.694 165.43C213.694 165.317 213.711 165.205 213.743 165.096L228.461 115.918Z",
    fill: "#D0D0D0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.375 115.918L243.542 166.595H213.208L228.375 115.918Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.375 117.424C228.375 153.407 228.375 171.836 228.375 172.711C228.375 171.836 228.375 153.407 228.375 117.424Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.045 140.382C225.934 144.506 227.878 146.642 227.878 146.79C227.878 146.642 225.934 144.506 222.045 140.382Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.045 155.528C234.489 149.166 237.211 146.059 237.211 146.208C237.211 146.059 234.489 149.166 229.045 155.528Z",
    stroke: "#D0D0D0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.083 39.61L203.583 75.725L247.917 97.86L251.417 50.095L214.083 39.61Z",
    fill: "#D0D0D0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.25 41.94L205.312 72.6686C204.499 73.906 204.044 74.6932 203.946 75.0302C203.848 75.3671 204.46 75.9664 205.781 76.828L247.699 97.3503L249.415 51.7722L248.478 51.272L215.25 41.94Z",
    fill: "#D0D0D0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.083 39.61L203.583 75.725L247.917 97.86L251.417 50.095L214.083 39.61Z",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M214.083 39.61L246.75 96.1125",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M203.583 75.725C211.947 66.8567 218.753 61.0317 224 58.25C229.247 55.4683 238.386 52.9441 251.417 50.6775",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M225.42 78.1301C217.426 100.27 203.185 115.693 182.696 124.399",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M247.923 97.3361C251.619 106.8 257.178 109.69 264.603 106.008C270.803 102.775 276.329 90.9056 285.943 95.8508C292.912 99.9744 289.915 108.297 286.1 118.297C282.007 131.216 289.112 134.981 298.24 132.983",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M177.333 131.062C180.233 131.062 182.583 128.715 182.583 125.82C182.583 122.925 180.233 120.577 177.333 120.577C174.434 120.577 172.083 122.925 172.083 125.82C172.083 128.715 174.434 131.062 177.333 131.062Z",
    stroke: "#616161",
    strokeWidth: 3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M189.954 140.773L193.66 137.732",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M180.799 130.167L193.59 145.388L198.83 140.998",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M181.417 124.655C158.472 130.868 140.583 139.023 127.75 149.12C114.917 159.217 111.805 173.779 118.417 192.807",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M224.583 57.6675L225.167 78.6375L240.917 86.7925",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.917 111.258C163.917 113.187 162.35 114.753 160.417 114.753C158.485 114.753 156.917 113.187 156.917 111.258C156.917 109.328 158.485 107.763 160.417 107.763C162.35 107.763 163.917 109.328 163.917 111.258Z",
    stroke: "#D0D0D0",
    strokeWidth: 3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.583 114.17C167.293 114.17 166.25 115.214 166.25 116.5C166.25 117.786 167.293 118.83 168.583 118.83C169.872 118.83 170.917 117.786 170.917 116.5C170.917 115.214 169.872 114.17 168.583 114.17Z",
    fill: "#D0D0D0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.26 51.8425C145.972 51.8425 153.559 56.7274 157.556 63.9481C160.33 61.9455 163.711 60.7554 167.366 60.7554C176.755 60.7554 184.362 68.5142 184.362 78.085C184.362 87.6571 176.755 95.4159 167.366 95.4159C167.164 95.4159 166.963 95.3907 166.758 95.3835C163.689 99.8885 158.586 102.844 152.799 102.844C148.693 102.844 144.926 101.358 141.989 98.8854C140.461 99.2066 138.879 99.3779 137.26 99.3779C124.385 99.3779 114.732 88.937 114.732 75.8116C114.732 62.6849 124.385 51.8425 137.26 51.8425Z",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.219 110.669L146.448 92.6175H139.38C139.058 92.6175 138.797 92.3567 138.797 92.035C138.797 91.9903 138.802 91.9457 138.812 91.9022L144.002 69.7672C144.063 69.5038 144.299 69.3175 144.57 69.3175H159.404C159.726 69.3175 159.987 69.5783 159.987 69.9C159.987 70.0153 159.953 70.128 159.888 70.2239L150.35 84.4625H159.392C159.714 84.4625 159.975 84.7233 159.975 85.045C159.975 85.1621 159.94 85.2765 159.874 85.3732L142.261 111.159C142.08 111.425 141.717 111.494 141.451 111.312C141.243 111.17 141.149 110.911 141.219 110.669Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkError);
export default __webpack_public_path__ + "static/media/network_error.f6c699bfbb6d874604a7f6c4d3d86b32.svg";
export { ForwardRef as ReactComponent };